@if (visibleContainer) {
  <div class="border border-success rounded" [class.usage-card-grow]="containerGrow" [ngClass]="marginBottom">
    
    <div class="row">
      <div class="col-12">
        <div
          class="alert border-0 alert-primary d-flex justify-content-between align-items-center"
          [ngClass]="expandContainer ? 'mb-3' : 'mb-0'"
          role="alert"
        >
          <strong>{{chartTitle}}</strong>
          <div class="d-flex align-items-center" style="gap: 6px;">
            <span
              *ngIf="!expandContainer && showTitleHintText"
              class="text-muted"
              style="font-size: 0.85em;"
            >
              Chart
            </span>
            <i class="fs-5"
               [attr.data-bs-toggle]="'tooltip'"
               [attr.data-bs-title]="expandContainer ? 'Collapse' : 'Expand'"
               [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
               style="cursor: pointer; color: #198754;"
               (click)="toggleContainerExpansion()">
            </i>
            <i *ngIf="allowContainerClose"
               class="fs-3 bx bx-x"
               [attr.data-bs-toggle]="'tooltip'"
               data-bs-title="Close"
               style="cursor: pointer; color: #dc3545;"
               (click)="closeContainer()">
            </i>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row" [class.d-none]="!expandContainer">
      <div class="col-12">
        <div class="card">
          @if (iccidChartCosts != undefined) {
            <div class="card-body">
              <apx-chart #chartRef
                [chart]="iccidChartCosts.chart"
                [colors]="iccidChartCosts.colors"
                [dataLabels]="iccidChartCosts.dataLabels"
                dir="ltr"
                [fill]="iccidChartCosts.fill"
                [labels]="iccidChartCosts.labels"
                [markers]="iccidChartCosts.markers"
                [plotOptions]="iccidChartCosts.plotOptions"
                [series]="iccidChartCosts.series"
                [stroke]="iccidChartCosts.stroke"
                [title]="iccidChartCosts.title"
                [tooltip]="iccidChartCosts.tooltip"
                [xaxis]="iccidChartCosts.xaxis"
                [yaxis]="iccidChartCosts.yaxis"
              >
              </apx-chart>
            </div>
          } @else if (noData) {
            <div class="card-body">
              <div class="alert alert-danger mb-0 text-center" role="alert">
                No data available
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    
  </div>
}
